import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateName = async (dpsID, cgId, cg_name) =>
  axios.put(
    `/api/dps/${dpsID}/consortium_groups/${cgId}`,
    JSON.stringify({ cg_name })
  );
const addSuppliersToConsortiumGroup = async (dpsID, cgId, companyIds) =>
  axios.post(
    `/api/dps/${dpsID}/consortium_groups/${cgId}/companies`,
    JSON.stringify({
      dps_id: +dpsID,
      cg_id: +cgId,
      companies_ids: companyIds,
      company_type: 'supplier',
    })
  );
const removeSupplierFromConsortiumGroup = async (dpsID, cgId, cgcId) =>
  axios.delete(`/api/dps/${dpsID}/consortium_groups/${cgId}/companies/${cgcId}
`);

const updateConsortiumGroup = async ({
  dpsID,
  cgId,
  cg_name = '',
  removedSuppliers = [],
  addedSuppliers = [],
}) => {
  return Promise.all([
    cg_name ? updateName(dpsID, cgId, cg_name) : null,
    addedSuppliers.length ? addSuppliersToConsortiumGroup(dpsID, cgId, addedSuppliers) : null,
    ...removedSuppliers.map((cgcId) => removeSupplierFromConsortiumGroup(dpsID, cgId, cgcId)),
  ]);
};

export const useUpdateConsortiumGroup = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateConsortiumGroup,
    onSuccess: () => {
      enqueueSnackbar('Consortium group was succesfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      //   refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
